






























import { Vue, Component, Watch } from 'vue-property-decorator';
import Nav from '@/components/Nav.vue';
import Sidebar from '@/components/Sidebar.vue';
import Overlay from '@/components/Overlay.vue';
import MenuData from '@/data/Menu';

@Component({
  components: {
    Nav,
    Sidebar,
    Overlay,
  },
})
export default class DefaultLayout extends Vue {
  globalBreadcrumb: Array<object> = [];

  isSidebarActive = false;

  @Watch('$mq', { immediate: true, deep: true })
  onMqChange() {
    this.isSidebarActive = this.$mq === 'mdNav';
  }

  @Watch('$route', { immediate: true, deep: true })
  onUrlChange() {
    this.renderGlobalBreadcrumb();
  }

  async renderGlobalBreadcrumb() {
    this.globalBreadcrumb = [];
    const { menuList } = MenuData;
    let current;
    menuList.every((element: any) => {
      if (element.route === this.$route.path) {
        current = { ...element };
        return false;
      } else if ('child' in element) {
        const child = element.child.find((menu) => menu.route === this.$route.path);
        if (child) {
          current = child;
          return false;
        }
      }
      return true;
    });
    if ('parentName' in current) {
      const type = typeof current.parentName;
      if (type === 'string') {
        const parent: any = menuList.find((menu) => menu.name === current.parentName);
        this.globalBreadcrumb.push(parent);
      } else if (type === 'object') {
        const parent: any = menuList.find((menu) => menu.name === current.parentName[0]);
        const sub: any = parent.child.find((menu) => menu.name === current.parentName[1]);
        sub.isSub = true;
        this.globalBreadcrumb.push(parent, sub);
      }
    }
    this.globalBreadcrumb.push(current);
  }

  toggleSidebar() {
    const { isSidebarActive } = this;
    this.isSidebarActive = !isSidebarActive;
  }
}
